import { faqData } from '@/mocks/faq';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-foreground-600 text-sm">
            关于北条麻妃电影全集精选的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 list-none">
                <h3 className="font-heading font-medium text-foreground-900 text-sm pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}